import React, { useEffect, useState } from "react";
import "./ExperientialPost.css?__remix_sideEffect__"; // Assuming you have CSS for styling
import { Box, Button, Image, Text, useBreakpointValue } from "@chakra-ui/react";
import Outstanding from "../../../components/atoms/icons/outstanding.svg";
import { useTutor } from "../../../context/AiTutorContext";
import { useRoot } from "../../../context/RootContext";
import Crakers from "../../../assets/experiential/fireCrakers.json";
import Congrats from "../../../assets/experiential/congrats.gif";
import BackgroundCover from "../../../components/atoms/icons/expSuccessBackground.svg";
import pkg from "@inrscr/coschool-ui-components";
import LottiePlayer from "../../organisms/wall/LottiePlayer";
import wall_images from "../../../utils/wall/wall-imges";
import useStateRef from "react-usestateref";
import {
  getEmotionalMessageText,
  isEmptyOrNull } from
"../../../utils/common-utils";
import { StorageService } from "../../../utils/StorageUtils";
import Lottie from "react-lottie-player";

const ExperientialPost = ({ goBack, goToWall, itemTitle, item }) => {
  const { PostCard } = pkg;
  const { taskStatus } = useTutor();
  const { setHandleTakeupNextTask } = useRoot();
  let userId = "";
  const [userInfo, setUserInfo, userInfoRef] = useStateRef({});
  const [messageText, setMessageText] = useState("");
  const divStyle = {
    backgroundImage: `url(${BackgroundCover})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",
    height: "100vh",
    backgroundRepeat: "no-repeat"
  };

  const vinStyle = {
    backgroundImage: `url(${Congrats})`,
    backgroundSize: "cover", // Adjust this property as needed
    backgroundPosition: "center", // Adjust this property as needed
    width: "300px",
    height: "130px" // Adjust the height as needed
  };

  const isMobile = useBreakpointValue({
    base: true,
    md: false,
    lg: false
  });

  const getMessageText = async () => {
    let text = await getEmotionalMessageText(22);

    // Replace placeholder with student's name if present
    if (text.includes("@@studentName") || text.includes("@@studentname")) {
      text = text.replace(
        /@@studentName|@@studentname/g,
        `${userInfoRef.current?.firstName}`
      );
    }

    if (text.includes("@@linebreak")) {
      text = text.replace(/@@linebreak/g, `\n`);
    }

    if (text.includes("@@experientialactivitytitle")) {
      text = text.replace(
        "@@experientialactivitytitle",
        `${experientialLearningData?.activityInfo?.name}`
      );
    }

    if (text.includes("@@topicname")) {
      text = text.replace(
        "@@topicname",
        `${experientialLearningData?.topicName}`
      );
    }

    setMessageText(text);
  };

  useEffect(() => {
    userId = StorageService.getItem("xUserId");
    let userDetails = StorageService.getItem("user_additional_details");
    userDetails =
    typeof userDetails === "object" ? userDetails : JSON.parse(userDetails);
    let data = {
      _id: userId,
      phoneNumber: userDetails?.phoneNumber,
      firstName: userDetails?.firstName,
      lastName: userDetails?.lastName,
      school: userDetails?.schoolName,
      grade: userDetails?.grade,
      grade_name: userDetails?.grade_name
    };
    setUserInfo(data);
    getMessageText();
  }, []);

  console.log("item", item);
  console.log("item title", itemTitle);

  return (
    <div className="exp-modal" style={divStyle}>
      {/* <LottiePlayer
         options={{
           loop: false,
           autoplay: true,
           animationData: Crakers,
         }}
          // height={"100%"}
         // width={"100%"}
        /> */
      }

      <div className="exp-modal-content">
        {/* <Assistant text={taskStatus} /> */}

        {/* <VirtualAssistant textPositon="bottom" text={taskStatus} /> */}
        <div style={{ display: "flex" }}>
          {/* <div style={{ ...vinStyle, transform: "scaleX(-1)" }}></div> */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              height: "max-content",
              padding: "0 30px",
              marginBottom: "30px"
            }}>

            <Lottie
              animationData={wall_images.outstandingLottie}
              play
              loop={false}
              // style={{
              //   width: "50%",
              //   height: "50%",
              // }}
              className="outstandingLottie" />


            <div>
              <Text
              // maxWidth={"100%"}
              w={"100%"}
              paddingLeft={"10px"}
              fontFamily={"Poppins"}
              fontWeight={400}
              fontSize={"14px"}
              lineHeight={"24px"}
              textColor={"#6D6BAE"}>

                {messageText}
              </Text>
            </div>
          </div>
        </div>
        <Box>
          <PostCard
            key={userInfoRef.current?._id}
            userInfo={userInfoRef.current}
            loginUserId={userInfoRef.current?._id}
            attachments={item?.attachments}
            description={item?.content}
            clapsCount={item?.clapsCount}
            commentsCount={item?.commentsCount}
            handleClick={() => {

              // handleNavigate(item);
            }} isBlur={item?.activity?.isUserPosted == false}
            isShareActivity={item?.activity?.isShareActivity}
            icons={{
              clap: wall_images.clap,
              comments: wall_images.comment,
              pdf: wall_images.pdf,
              doc: wall_images.doc,
              ppt: wall_images.ppt,
              videIcon: wall_images.video_icon,
              moreIcon: wall_images.more,
              vote: wall_images.vote,
              activeVote: wall_images.activeVote
            }}
            title={itemTitle}
            isFromExperiential={true} />

        </Box>
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "center",
            marginTop: "66px",
            gap: "16px"
          }}>

          <Box
            w={"159px"}
            h={"45px"}
            onClick={goBack}
            borderRadius={"12px"}
            borderWidth={"1px"}
            borderColor={"#21146D"}
            textColor={"#21146D"}
            textAlign={"center"}
            cursor={"pointer"}
            alignItems={"center"}
            alignContent={"center"}>

            Back
          </Box>
          <Box
            w={"max=content"}
            h={"45px"}
            p={2}
            onClick={goToWall}
            borderRadius={"12px"}
            backgroundColor={"#5F4DC7"}
            textColor={"white"}
            textAlign={"center"}
            cursor={"pointer"}
            alignItems={"center"}
            alignContent={"center"}>

            View it on Experiential Hub
          </Box>
        </div>
      </div>
    </div>);

};

export default ExperientialPost;